// extracted by mini-css-extract-plugin
export default {"RecipeContainer":"RecipeContainer2weP2UWHlgsf","RecipeContainer-item":"RecipeContainer-item1gos8kezE0rA"};